import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, ambassadorOnly = false, partnerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-void">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-cyan border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to={ambassadorOnly ? "/ambassadeur" : "/connexion"} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  if (ambassadorOnly && user.role !== "ambassador" && user.role !== "admin") return <Navigate to="/app" replace />;
  if (partnerOnly && user.role !== "partner" && user.role !== "admin" && !user.partner_code) return <Navigate to="/connexion" replace />;
  return children;
}
